import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Table, Tbody, Td, Thead, Tr, Th } from 'react-super-responsive-table';
import { Card } from 'react-bootstrap';
import { useSidebar } from './SidebarContext';
import { useAuth } from './AuthContext';
import ProfileDropdown from './commonComponents/ProfileDropdown';
import { useInstitute } from './commonComponents/InstituteContext';
import { LuGraduationCap } from 'react-icons/lu';

const DischargedStudentFees = () => {
  const { logout } = useAuth();
  const { isCollapsed } = useSidebar();
  const [marginLeft, setMarginLeft] = useState('0px');
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  );
  const [logoError, setLogoError] = useState(false);
  const { logo, name, id } = useInstitute();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245;
        const collapsedWidth = 85;
        const gap = 1;

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        );
      } else {
        setMarginLeft('0px');
      }

      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isCollapsed]);

  const location = useLocation();
  const { student_id, selectedData = [], studentName = '' } = location.state || {};

  return (
    <>
      <style>
        {`
          @media (max-width: 767.98px) {
            .responsive-btn {
              margin-top: 5px !important;
              padding: 0.25rem 0.5rem !important;
              font-size: 0.875rem !important;
            }
          }
        `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px',
        }}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
          <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
            <div 
              className="d-flex justify-content-between align-items-center"
              style={{
                background: '#F3F4F6',
                paddingLeft: '28px',
                paddingRight: '28px',
                paddingTop: '12px',
                paddingBottom: '12px',
                overflow: 'visible',
                borderBottom: '1px solid #D1D3D4',
                width: '100%',
              }}
            >
              {/* Left: Title */}
              <div className="d-flex align-items-center gap-3">
                {/* School Logo */}
                <div style={{ 
                  width: '40px', 
                  height: '40px', 
                  borderRadius: '50%', 
                  overflow: 'hidden', 
                  background: '#223843',
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  flexShrink: 0,
                }}>
                  {!logoError ? (
                    <img 
                      src={logo} 
                      alt="School Logo" 
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={() => setLogoError(true)}
                    />
                  ) : (
                    <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                  )}
                </div>
                
                <h3 
                  className="m-0 fw-bold" 
                  style={{ 
                    letterSpacing: '-0.02em',
                    overflow: 'visible',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: 'clamp(18px, 2.5vw, 22px)',
                    color: '#111827',
                    lineHeight: '1.2',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  Fees Details for{' '}
                  <span style={{ color: '#223843', fontWeight: '600' }}>
                    {studentName || 'Student'}
                  </span>
                </h3>
              </div>
                
              {/* Right: Profile Icon with Dropdown */}
              {!isMobile && (
                <ProfileDropdown logout={logout} />
              )}
            </div>
          </div>
        </div>

        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px',
          }}
        >
          {/* Table */}
          <Card style={{ border: '1px solid #D1D3D4', borderRadius: '12px', overflow: 'hidden', backgroundColor: '#ffffff' }}>
            <Table className="table mb-0" style={{ borderRadius: '12px', overflow: 'hidden' }}>
              <Thead>
                <Tr style={{ backgroundColor: '#F3F4F6' }}>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    Transaction Amount (₹)
                  </Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    Start Date
                  </Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    End Date
                  </Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    Transaction Date
                  </Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    Payment Method
                  </Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    Fees Status
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {!student_id || selectedData.length === 0 ? (
                  <Tr>
                    <Td colSpan="6" className="text-center" style={{ padding: '40px', fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
                      No data found
                    </Td>
                  </Tr>
                ) : (
                  selectedData
                    .filter(
                      (fee) =>
                        fee.fees_status === 'pending' ||
                        fee.fees_status === 'complete'
                    )
                    .map((fee, index) => (
                      <Tr 
                        key={fee.id}
                        style={{ 
                          backgroundColor: index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                          transition: 'background-color 0.2s ease',
                          borderBottom: '1px solid #E5E7EB',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.06)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)'
                        }}
                      >
                        <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign: 'left', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          ₹ {fee.transaction_amount || fee.amount}
                        </Td>
                        <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign: 'left', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          {new Date(fee.start_date).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                          })}
                        </Td>
                        <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign: 'left', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          {new Date(fee.end_date).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                          })}
                        </Td>
                        <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign: 'left', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          {fee.transaction_date
                            ? new Date(fee.transaction_date).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: 'long',
                                year: 'numeric',
                              })
                            : '-'}
                        </Td>
                        <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign: 'left', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          {fee.payment_method || '-'}
                        </Td>
                        <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign: 'left', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          <span
                            style={{
                              padding: '4px 12px',
                              borderRadius: '12px',
                              fontSize: '12px',
                              fontWeight: '600',
                              fontFamily: 'Inter, system-ui, sans-serif',
                              backgroundColor: fee.fees_status === 'complete' ? '#ECFDF5' : '#FEF3C7',
                              color: fee.fees_status === 'complete' ? '#10B981' : '#F59E0B',
                              textTransform: 'capitalize',
                            }}
                          >
                            {fee.fees_status}
                          </span>
                        </Td>
                      </Tr>
                    ))
                )}
              </Tbody>
            </Table>
          </Card>
        </div>
      </div>
    </>
  );
};

export default DischargedStudentFees;
